import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from "@mui/styles/makeStyles";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";

const useStyles = makeStyles(sectionTextStyle);

export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>
            The reason your LinkedIn campaign is being rejected is probably
            because you’re using too many emojis…
          </h3>
          <p>
            Here at Tribalism one of our many talents is campaign management and
            media creation. We have worked with multiple clients from different
            industries, and have worked on many different types of campaigns and
            have come to notice an interesting pattern that we will be
            discussing in the following blog article - as we believe there isn't
            enough information about this topic on the net currently.
            <br />
            <br />
            It seems LinkedIn is not a fan of emojis when it comes to
            advertising, especially videos. Oddly enough it seems that if you
            use more than 4 emojis in the caption of your video creative, it
            will get rejected.
            <br />
            <br />
            This is bizarre, seeing as we have used the exact same
            copy/text/captions for our clients imagery ads which were approved
            (and contain more than 4 emojis), yet for the video creatives -
            rejection is all that appears 🙄
            <br />
            <br />
          </p>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "600px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2021-06-30-linkedin/blog-image-two-resize.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Look familiar?</i>
            </p>
          </GridItem>
        </div>
        <GridItem xs={12} sm={8} md={8}>
          <p>
            Upon reading the below feedback of why our video creatives were
            being rejected and applying the feedback by removing emojis, it
            seems the only way for approval is unfortunately to either limit the
            use of emojis to a maximum of 4 or remove them completely, leaving
            the text plain and dull, which surely won't be as engaging for the
            audience and therefore defeat the purpose of the ad and destroy the
            goal of getting likes, shares, follows etc...
          </p>
        </GridItem>
        <div style={{ textAlign: "center", maxWidth: "600px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/posts/2021-06-30-linkedin/blog-image-three-resize.webp"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Creative Rejected Alert</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <p>
            To try and better understand this bias LinkedIn has towards emojis
            is also a struggle, as it seems there isn't enough explanation on
            the net.
            <br />
            <br />
            There are in fact many sources which show ads that feature emojis
            have a higher click-through rate and much more engagement in
            comparison to the performance of the same ad without emojis (see
            here:{" "}
            <a
              href="https://sproutsocial.com/insights/emoji-marketing/"
              _target="blank"
            >
              Sprout Social
            </a>
            ). Furthermore, emojis can increase the number of reactions and
            comments on your ads, so why is LinkedIn restricting video creatives
            to only 4 emojis? 🤔
            <br />
            <br />
            One of the only explanations that we could find said using too many
            emojis or the “wrong type” of emojis creates a misleading message
            and therefore causes the ad to get rejected. If this is the case why
            have previous ads been approved with the exact same content, and
            only video creatives are being negatively affected?
            <br />
            <br />
            Regardless of the hurdles we managed to overcome this issue and
            create high quality gifs and video ads for our clients such as the
            ads below 😁
          </p>

          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <img
                src="/img/posts/2021-06-30-linkedin/blog-image-four-resize.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Bizcap Gif Ad
                </i>
              </div>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <img
                src="/img/posts/2021-06-30-linkedin/blog-image-five-resize.webp"
                alt="..."
                className={imgClasses}
              />
              <div style={{ textAlign: "center" }}>
                <i>
                  <br />
                  Quallogi Video Ad
                </i>
              </div>
            </GridItem>
          </GridContainer>

          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
